import * as React from "react";
import {Action} from "../App";
import {CharacterExplanation} from "./CharacterExplanation";
import {DiacriticNote} from "../DiacriticNote";
import {StyledQuizCard} from "./StyledQuizCard";
import {Button} from "semantic-ui-react";
import {ActionDisplay} from "./ActionDisplay";

interface IProps {
    action: Action,
    knownCharacters: string,
    showQuiz():void,
    showLanguageError(): void,
}

interface IState {
}

export class CharacterIntroduction extends React.Component<IProps, IState> {
    public render() {
        if(this.props.action !== Action.introducing) {
            return "";
        }

        let character = this.props.knownCharacters[this.props.knownCharacters.length - 1];
        return (
            <StyledQuizCard>
                <div>Congratulations! Time to add another character:</div>
                <CharacterExplanation character={character} showLanguageError={this.props.showLanguageError}/>
                <DiacriticNote character={character} knownCharacters={this.props.knownCharacters}/>
                <ActionDisplay>
                    <Button onClick={() => this.props.showQuiz()}>Let's go!</Button>
                </ActionDisplay>
            </StyledQuizCard>
        )
    };
}


// WEBPACK FOOTER //
// ./src/components/QuizBox/CharacterIntroduction.tsx